import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectAccountWebPagesListItems } from "../../../../../redux/web-pages/selector";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table";
import { accountWebPages } from "../../../../../redux/web-pages/action";
import storePersist from "../../../../../redux/storePersist";
import { accountWebPageCards } from "../../../../../redux/web-page-cards/action";
import { toast } from "react-toastify";
import { selectAccountTypesListItems } from "../../../../../redux/account-types/selector";
import { accountTypes } from "../../../../../redux/account-types/action";


const AgencyAccountWebPages = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const webPagesItems = useSelector(selectAccountWebPagesListItems)
  var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
  const accountTypeItems = useSelector(selectAccountTypesListItems)
  const accountTypeId = accountTypeItems?.result?.items?.find(item => item.Name === "Vendor")?.Id;
  console.log(accountTypeId, accountTypeItems?.result?.items, 'accountTypeId')
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const [
    updatedRowData,
    setUpdatedRowData
  ] = useState<any>([]);
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'WebPage Name',searchField: 'Name', filter: true,
        filterType: 'text'  },
      { field: 'AccountName', headerName: 'Account Name',searchField: 'AccountName', filter: true,
        filterType: 'text'  },
      { field: 'HostingUrl', headerName: 'HostingUrl',searchField: 'HostingUrl', filter: true,
        filterType: 'text', input: true, type: 'text' },
      { field: 'MappedDomain', headerName: 'MappedDomain',searchField: 'MappedDomain', filter: true,
        filterType: 'text',input: true, type: 'text' },
      { field: 'DisplayOrder', headerName: 'DisplayOrder', sortable: false, filter: false, input: true, type: 'text' },
      { field: 'Remarks', headerName: 'Remarks', input: true, type: 'text' },
      { field: 'TableUrl', headerName: 'Table URL' },
      { field: 'StorageEndpointUrl', headerName: 'Storage End point URL' },
      { field: 'CDNEndpointUrl', headerName: 'CDN End point URL' },
      { field: 'BlobFolderUrl', headerName: 'Blob Folder Url' },
    ]);
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column){
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    dispatch(accountWebPages.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
      "PageNumber": pageData,
      "PageSize": pageSize,
      "SortField": "Id",
      "SortOrder": "desc",
      "Searches": searchCriteria,
      }}))
  }


  const handleReloadData = () => {
    dispatch(accountWebPages.list({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",

      }
    }))
  }
  const handleAdd = () => {
    navigate(`${0}`)
  }
  const handleDefaultWebPageAdd = () => {
    navigate(`/management/cms/web-page/${0}`)
  }
  const handleInputChange = (event: any, field: any, row: any) => {
    const { value } = event.target;
    setUpdatedRowData((prevUser: any) => ({
      ...prevUser,
      [field]: value,
    }));
  };


  const handlereset = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'update' }))
    await dispatch(accountWebPageCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/sync-card-with-platform-card-template`, entity: 'accountWebPageCards', jsonData: {

        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              TenantId: tenantId,
              PlatformWebSitePageId: data?.PlatformWebSitePageId,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId,
              VendorWebPageId: data?.Id
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Reset the Web Page successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",

        }
      }))
    });

  }

  const handleUpdateTenantWebsite = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'update' }))
    await dispatch(accountWebPageCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/add-new-cards-to-tenant-webpage-cards`, entity: 'accountWebPageCards', jsonData: {

        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              TenantId: tenantId,
              PlatformWebSitePageId: data?.PlatformWebSitePageId,
              VendorWebPageId: data?.Id,
              AccountTypeId: data?.AccountTypeId,
              AccountId: data?.AccountId
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Add New cards to the Webpages successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",

        }
      }))
    });
  }
  // Reset for all vendors in website related protocols

  const handleresetForAllVendors = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'update' }))
    await dispatch(accountWebPageCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/sync-card-with-platform-card-template`, entity: 'accountWebPageCards', jsonData: {

        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              TenantId: tenantId,
              PlatformWebSitePageId: data?.PlatformWebSitePageId,
              AccountId: 0,
              AccountTypeId: accountTypeId,
              VendorWebPageId: 0
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Reset the Web Page successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",

        }
      }))
    });

  }
  // Add new cards for all vendors in website related protocols
  const handleAddNewCardsForAllVendors = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'update' }))
    await dispatch(accountWebPageCards.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/add-new-cards-to-tenant-webpage-cards`, entity: 'accountWebPageCards', jsonData: {

        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              TenantId: tenantId,
              PlatformWebSitePageId: data?.PlatformWebSitePageId,
              VendorWebPageId: 0,
              AccountTypeId: accountTypeId,
              AccountId: 0
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Add New cards to the Webpages successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",

        }
      }))
    });
  }
  const handleEnableTenantWebsite = async (data: any) => {
    await dispatch(accountWebPages.resetAction({ actionType: 'update' }))
    await dispatch(accountWebPages.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts`, entity: 'accountWebPages', jsonData: {
        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              ...data
            }
          }
        ]

      }
    }))
      .then(() => {
        // toast.info(' Webpages activated successfully')
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",

          }
        }))
      });

  }


  const handleSave = async (data: any) => {
    await dispatch(accountWebPages.resetAction({ actionType: 'update' }))
    await dispatch(accountWebPages.update({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts`, entity: 'accountWebPages', jsonData: {
        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              Id: data?.Id,
              TenantId: tenantId,
              AccountTypeId: data?.AccountTypeId,
              AccountId: data?.AccountId,
              VendorWebPageId: data?.VendorWebPageId,
              PlatformWebSitePageId: data?.PlatformWebSitePageId,
              Name: data?.Name,
              VersionId: data?.VersionId,
              HostingUrl: updatedRowData?.HostingUrl || data?.HostingUrl,
              MappedDomain: updatedRowData?.MappedDomain || data?.MappedDomain,
              DisplayOrder: updatedRowData?.DisplayOrder || data?.DisplayOrder,
              Remarks: updatedRowData?.Remarks || data?.Remarks
            }
          }
        ]

      }
    }))
      .then(() => {
        // toast.info('Webpages details Updated successfully')
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",

          }
        }))
      });
    setUpdatedRowData({})
  }
  const handleDelete = (data: any) => {
    dispatch(accountWebPages.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/delete`,
      entity: 'accountWebPages',
      jsonData: {
        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              Id: data?.Id,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId
            }

          }
        ]
      }
    })).then(() => {
      // toast.info('Webpages deleted successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    });

  }

  // Delete for all vendors in website related protocols
  const handleDeleteForAllVendors = () => {
    dispatch(accountWebPages.delete({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/delete`,
      entity: 'accountWebPages',
      jsonData: {
        Records: [
          {
            "Context": {
              "Subscription": "UCP",
              "Domain": "Commerce",
              "SubDomains": [
                "Retail",
                "F&B",
                "Fashion"
              ],
              "Network": "Vendor",
              "Application": "Management",
              "Channel": "Portal"
            },
            "Message": {
              Id: 0,
              AccountId: 0,
              AccountTypeId: accountTypeId
            }

          }
        ]
      }
    })).then(() => {
      // toast.info('Webpages deleted successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    });

  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const additionButtons: any = [
    {
      name: 'Add WebPage',
      callback: () => handleAdd(),
    },
    {
      name: 'Add Default',
      callback: () => handleDefaultWebPageAdd(),
    },
    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
      <title>Reload</title>
      <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>,
    // name: 'Reload',
    callback: () => handleReloadData(),
    },
  ];
  const fetchAccountWebPages = () => {
    dispatch(accountTypes.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`, entity: 'accountTypes', jsonData: {
      }
    })).then(() => {
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'tenantWebsites', jsonData: {

          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    })
  }
  // add new cards to CDN with selected account type 
  const handleUpdateCDNWebPages = async () => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/update`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: 0,
              AccountId: 0,
              AccountTypeId: accountTypeId
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Add New cards for the webpages is published in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  const handleEnableDBNAttributesAccountWebPage = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/enable`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Add New cards for the webpages is published in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });

  }

  const handlePublishAccountWebPageInMangoDB = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/cms/web-pages/accounts/publish`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Add New cards for the webpages is published in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });

  }
  const handleEnableSEOAccountWebPage = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/enable-seo-folder`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Add New cards for the webpages is published in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });

  }
  // Publish all  to CDN with selected account type 

  const handlePublishWebPages = async () => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/publish`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: 0,
              AccountId: 0,
              AccountTypeId: accountTypeId
            }
          }
        ]

      }
    }))

      .then(() => {
        // toast.info('Webpages published in CDN  successfully')
        dispatch(accountWebPages.list({
          url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

            "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",


          }
        }))
      });

  }

  // Reset  all webpages in  CDN with selected account type 

  const handleResetCDNWebpages = async () => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/sync`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: 0,
              AccountId: 0,
              AccountTypeId: accountTypeId
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Reset Webpages  in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  // Delete  all webpages in  CDN with selected account type 

  const handleDeleteCDNWebpages = async () => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/remove`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: 0,
              AccountId: 0,
              AccountTypeId: accountTypeId
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Delete Webpages  in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",

        }
      }))
    });
  }

  // Publish to CDN with selected account type and Account Id

  const handlePublishWebPage = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/publish`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Webpages published in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    });

  }

  // Reset webpages in  CDN with selected account type and Account Id

  const handleResetCDNWebpage = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/sync`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Reset Webpages  in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }

  // Delete webpages in  CDN with selected account type and Account Id

  const handleDeleteCDNWebpage = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/remove`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId
            }
          }
        ]
      }
    })).then(() => {
      // toast.info('Delete Webpages  in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });

  }

  // add new cards to all webpages CDN with selected account type and Account Id
  const handleUpdateCDNWebPage = async (data: any) => {
    await dispatch(accountWebPageCards.resetAction({ actionType: 'create' }))
    await dispatch(accountWebPageCards.create({
      url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-page-cards/accounts/update`, entity: 'accountWebPageCards', jsonData: {
        Records: [
          {
            "Context": {},
            "Message": {
              TenantId: tenantId,
              Id: data?.Id,
              AccountId: data?.AccountId,
              AccountTypeId: data?.AccountTypeId
            }
          }
        ]

      }
    })).then(() => {
      // toast.info('Add New cards for the webpages is published in CDN  successfully')
      dispatch(accountWebPages.list({
        url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/cms/web-pages/accounts/list`, entity: 'accountWebPages', jsonData: {

          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",


        }
      }))
    });

  }
  useEffect(() => {
    createColumnDefs()
    fetchAccountWebPages()
  }, [pageData, pageSize])

  return (
    <>
      {webPagesItems?.isLoading ? <PageLoader />
        :
        <Table enableFilter={true}
        onSearch={handleSearch} columnData={columnDefs} rowData={webPagesItems?.result?.items} setPageData={setPageData}
          handlereset={handlereset} handleEnableTenantWebsite={handleEnableTenantWebsite} handleInputChange={handleInputChange} handleUpdateTenantWebsite={handleUpdateTenantWebsite} paginationData={webPagesItems?.result?.pagination} onDelete={handleDelete} additionButtons={additionButtons} headingName="Web Pages"
          handlePublishWebPage={handlePublishWebPage} onEdit={handleEdit} IsWebPages={true} handleSave={handleSave}
          handleUpdateCDNWebPage={handleUpdateCDNWebPage} handleCDNDelete={handleDeleteCDNWebpage}
          handleCDNReset={handleResetCDNWebpage}
          handleUpdateCDNWebPages={handleUpdateCDNWebPages}
          handleResetCDNWebpages={handleResetCDNWebpages}
          handleDeleteCDNWebpages={handleDeleteCDNWebpages}
          handlePublishWebPages={handlePublishWebPages}
          handleDeleteForAllVendors={handleDeleteForAllVendors}
          handleresetForAllVendors={handleresetForAllVendors}
          handleAddNewCardsForAllVendors={handleAddNewCardsForAllVendors}
          setPageSize={setPageSize}
          handleEnableSEOAccountWebPage={handleEnableSEOAccountWebPage} 
          handleEnableDBNAttributesAccountWebPage={handleEnableDBNAttributesAccountWebPage}
          handlePublishAccountWebPageInMangoDB={handlePublishAccountWebPageInMangoDB}
          />
      }
    </>
  );
};

export default AgencyAccountWebPages;


